import { CapsuleDef } from './types';

export class Router {
	map: { [name: string]: CapsuleDef } = {};

	get(name: string): CapsuleDef | undefined {
		return this.map[name];
	}

	register(capsules: CapsuleDef[]): Router {
		capsules.forEach(capsuleDef => {
			this.map[capsuleDef.name] = capsuleDef;
		});

		return this;
	}
}
